module.exports = __webpack_public_path__ + "static/media/skylinelogo.60e7e393.png";